import React from 'react';
import i18n from 'util/i18n';
import { formConfig } from 'config/forms';
import { getNumberOfYearsString } from 'helpers/text';

import { Summary, DateSummary } from 'components/Summary';
import { LEGAL, LEGAL_COURT, LEGAL_CRIMINAL_CONVICTIONS } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import BranchCollection from 'components/Form/BranchCollection';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Field from 'components/Form/Field';
import Offense from './Police/Offense';
import Conviction from './Convictions';

const sectionConfig = {
  key: LEGAL_CRIMINAL_CONVICTIONS.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_CRIMINAL_CONVICTIONS.name,
  storeKey: LEGAL_CRIMINAL_CONVICTIONS.storeKey,
};

export class CriminalConvictions extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };


  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const date = DateSummary(o.CivilActionDate);
    const courtName = (o.CourtName || {}).value || '';

    return Summary({
      type: i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.itemType'),
      index,
      left: courtName,
      right: date,
      placeholder: i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.summary'),
    });
  };

  render() {
    const { formType, errors } = this.props;
    const formTypeConfig = formType && formConfig[formType];
    const years = formTypeConfig && formTypeConfig.LEGAL_COURT_YEARS;
    const numberOfYearsString = getNumberOfYearsString(years);
    const branchLabelCopy = i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.label');

    const collectionErrors = errors && errors.filter((e) => e.indexOf('List.branchCollection') === 0);
    return (
      <div
        className="section-content non-criminal-court-actions"
        data-section={LEGAL.key}
        data-subsection={LEGAL_CRIMINAL_CONVICTIONS.key}
      >
        <h1 className="section-header">{i18n.t('legal.pvq.criminalConvictions.intro.title')}</h1>
        <h4 className="no-margin-bottom">{i18n.t(('legal.pvq.criminalConvictions.intro.body'))}</h4>

        <Field
          titleSize="h3"
          className="bottom-spacing"
        >
          {[
            i18n.m('legal.pvq.criminalConvictions.para.bullet1'),
            i18n.m('legal.pvq.criminalConvictions.para.bullet2'),
            i18n.m('legal.pvq.criminalConvictions.para.bullet3'),
            i18n.m('legal.pvq.criminalConvictions.para.bullet4'),
            i18n.m('legal.pvq.criminalConvictions.para.bullet5'),

          ]}
        </Field>

        <Field
          titleSize="h3"
          className="bottom-spacing"
        >
          <h4 className="no-margin-bottom">{i18n.t('legal.pvq.criminalConvictions.para2.subtitle')}</h4>
          {[
            i18n.m('legal.pvq.criminalConvictions.para2.bullet1'),
          ]}
        </Field>



        <BranchCollection
          {...this.props.List}
          branchName="has_criminal_convictions"
          label={branchLabelCopy}
          labelSize="h4"
          warning
          description={i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.description')}
          appendTitle={i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.appendTitle')}
          appendLabel={i18n.t('legal.pvq.criminalConvictions.hasCriminalConvictions.collection.appendLabel')}
          appendSize="h4"
          onUpdate={this.updateList}
          scrollToBottom={this.props.scrollToBottom}
          required={this.props.required}
          onError={this.handleError}
          scrollIntoView={this.props.scrollIntoView}
          errors={collectionErrors}
          attribute="List"
        >

          <Conviction
            {...this.props.List}
            updateList={this.updateList}
            name="Item"
            bind
            formType={this.props.formType}
            addressBooks={this.props.addressBooks}
            dispatch={this.props.dispatch}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            defaultState={this.props.defaultState}
            onError={this.handleError}
            attribute="List"


          />

        </BranchCollection>

      </div>
    );
  }
}

CriminalConvictions.defaultProps = {
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'criminalConvictions',
  defaultState: true,
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(CriminalConvictions, sectionConfig);
